// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Pv3Y","content":"styles_content__vcq3h"};